import { set } from 'lodash/fp';
import createReducer from '../../../../../../helpers/createReducer';
import { fetchROPicklistForView } from '../../../../sagas/routines';
import { resetROPicklistView } from '../../../../actions/routes/ro-picklist/view';

const initialState = {
  data: null,
  fetching: false,
  fetched: false
};

const fetchROPicklistViewHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const resetROPicklistViewHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchROPicklistViewHandler(fetchROPicklistForView),
  ...resetROPicklistViewHandler(resetROPicklistView)
});
